
import {
    onMounted,
    reactive,
    ref,
    defineComponent,
    getCurrentInstance,
} from 'vue'
import { message, Modal } from 'ant-design-vue'
import { login } from './request'
import { useRouter, useRoute } from 'vue-router'

// import logo from '/@/assets/images/logo.png'

export default defineComponent({
    setup() {
        const router = useRouter()
        const loading = ref<boolean>(false)
        const formRef = ref()
        let form = reactive({
            username: '',
            password: '',
        })
        let rules = {
            username: [
                {
                    required: true,
                    message: '请输入账号',
                },
            ],
            password: [
                {
                    required: true,
                    message: '请输入密码',
                },
            ],
        }

        async function onSubmit() {
            formRef.value.validate().then(async () => {
                let params = {
                    ...form,
                }
                loading.value = true
                try {
                    let res = await login(params)
                    let data = res.data
                    if (data.result) {
                        router.push({
                            name: 'business',
                        })
                        message.success('登录成功')
                    } else {
                        message.error(data.msg)
                    }
                    loading.value = false
                } catch (e) {
                    console.error(e)
                    loading.value = true
                }
            })
        }
        return {
            onSubmit,
            formRef,
            form,
            rules,
            // logo,
        }
    },
})
